import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';

export default function DisclaimerSmall({
  isOpen,
  onToggle,
}) {
  const history = useHistory();

  const [disclaimerLink, setDisclaimerLink] = useState(null);

  useEffect(() => {
    const loadDisclaimer = async () => {
      try {
        const response = await axios.get(configData.LANDNOTIFICATION_SERVER_URL + "home/links?language=ENGLISH", { withCredentials: true });
        const links = response.data.content.paragraphs;
        if (links && links.length > 0) {
          const filteredDisclaimerList = links.filter((link) => link.heading === "Disclaimer");
          if (filteredDisclaimerList && filteredDisclaimerList.length === 1) {
            setDisclaimerLink(filteredDisclaimerList[0].paragraphContent);
          }
        }
      } catch (error) {
        handleError(error, history);
      }
    };

    loadDisclaimer();
  }, [history]);

  return (
    <div
      style={{
        ...styles.container,
        boxShadow: isOpen
          ? "0 4px 10px rgba(0,0,0,0.08)"
          : "0 1px 3px rgba(0,0,0,0.05)",
      }}
    >
      {/* Header */}
      <div
        style={{
          ...styles.header,
          backgroundColor: isOpen ? "#5A6268" : "#6C757D",
        }}
        onClick={onToggle}
      >
        <span>Disclaimer</span>

        {/* Arrow with smooth rotation */}
        <span
          style={{
            ...styles.icon,
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            display: "inline-block",
          }}
        >
          ▼
        </span>
      </div>

      {/* Animated Content */}
      <div
        style={{
          ...styles.wrapper,
          maxHeight: isOpen ? "300px" : "0px",
        }}
      >
        <div
          style={{
            ...styles.content,
            opacity: isOpen ? 1 : 0,
            transition: "opacity 0.2s ease 0.08s",
          }}
        >
          {disclaimerLink && (
            <a target="_blank" rel="noopener noreferrer" href={disclaimerLink} style={styles.link}>
              Click Here
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

// Styles
const styles = {

  container: {
    marginTop: "16px",
    border: "2px solid #6C757D",
    borderRadius: "6px",
    overflow: "hidden",
    transition: "box-shadow 0.3s ease",
    boxShadow: "0 4px 12px rgba(108, 117, 125, 0.12)",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 12px",
    cursor: "pointer",
    backgroundColor: "#6C757D",
    fontWeight: "bold",
    color: "white",
    transition: "background-color 0.2s ease",
  },

  icon: {
    fontSize: "12px",
  },

  wrapper: {
    overflow: "hidden",
    transition: "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
  },

  content: {
    padding: "12px",
    backgroundColor: "white",
    fontSize: "14px",
    lineHeight: "1.5",
  },

  link: {
    color: "#3675A5",
    fontWeight: "bold",
  },

};
